module.exports = __webpack_public_path__ + "static/media/1040418200.17d492ed.jpg";